import StoryTellingModal from './StoryTellingModal';

export default StoryTellingModal;